__turbopack_context__.v({
  "wrapper": "NewsPlayer-module-scss-module__xyTjmq__wrapper",
});
